export default __webpack_public_path__ + "static/media/eye.0fd4357f.svg";